// extracted by mini-css-extract-plugin
export default {"actions":"organizations_actions__jZ97e"};